var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckSquareFormValidationCheckmarkSuccessBoxSquareTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1779 8.57505L10.5186 16.8992L7.18893 14.402M18.1483 1.5H6.4945C3.73612 1.5 1.5 3.73612 1.5 6.4945V18.1483C1.5 20.9068 3.73612 23.1428 6.4945 23.1428H18.1483C20.9068 23.1428 23.1428 20.9068 23.1428 18.1483V6.4945C23.1428 3.73612 20.9068 1.5 18.1483 1.5Z",
    stroke: "green",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSquareFormValidationCheckmarkSuccessBoxSquareTick);
export default __webpack_public_path__ + "static/media/check-square-form-validation-checkmark-success-box-square-tick.7ad2ddb26cf9011f595a15840c42f591.svg";
export { ForwardRef as ReactComponent };